var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgFilter = function SvgFilter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 9.83334C3.79357 9.83334 4.16667 10.2064 4.16667 10.6667V16.5C4.16667 16.9602 3.79357 17.3333 3.33333 17.3333C2.8731 17.3333 2.5 16.9602 2.5 16.5V10.6667C2.5 10.2064 2.8731 9.83334 3.33333 9.83334Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 0.666656C3.79357 0.666656 4.16667 1.03975 4.16667 1.49999V7.33332C4.16667 7.79356 3.79357 8.16666 3.33333 8.16666C2.8731 8.16666 2.5 7.79356 2.5 7.33332V1.49999C2.5 1.03975 2.8731 0.666656 3.33333 0.666656Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 8.16666C10.4601 8.16666 10.8332 8.53975 10.8332 8.99999V16.5C10.8332 16.9602 10.4601 17.3333 9.99984 17.3333C9.5396 17.3333 9.1665 16.9602 9.1665 16.5V8.99999C9.1665 8.53975 9.5396 8.16666 9.99984 8.16666Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 0.666656C10.4601 0.666656 10.8332 1.03975 10.8332 1.49999V5.66666C10.8332 6.12689 10.4601 6.49999 9.99984 6.49999C9.5396 6.49999 9.1665 6.12689 9.1665 5.66666V1.49999C9.1665 1.03975 9.5396 0.666656 9.99984 0.666656Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6668 11.5C17.1271 11.5 17.5002 11.8731 17.5002 12.3333V16.5C17.5002 16.9602 17.1271 17.3333 16.6668 17.3333C16.2066 17.3333 15.8335 16.9602 15.8335 16.5V12.3333C15.8335 11.8731 16.2066 11.5 16.6668 11.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6668 0.666656C17.1271 0.666656 17.5002 1.03975 17.5002 1.49999V8.99999C17.5002 9.46023 17.1271 9.83332 16.6668 9.83332C16.2066 9.83332 15.8335 9.46023 15.8335 8.99999V1.49999C15.8335 1.03975 16.2066 0.666656 16.6668 0.666656Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6667C0 10.2064 0.373096 9.83334 0.833333 9.83334H5.83333C6.29357 9.83334 6.66667 10.2064 6.66667 10.6667C6.66667 11.1269 6.29357 11.5 5.83333 11.5H0.833333C0.373096 11.5 0 11.1269 0 10.6667Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 5.66668C6.6665 5.20644 7.0396 4.83334 7.49984 4.83334H12.4998C12.9601 4.83334 13.3332 5.20644 13.3332 5.66668C13.3332 6.12691 12.9601 6.50001 12.4998 6.50001H7.49984C7.0396 6.50001 6.6665 6.12691 6.6665 5.66668Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 12.3333C13.3335 11.8731 13.7066 11.5 14.1668 11.5H19.1668C19.6271 11.5 20.0002 11.8731 20.0002 12.3333C20.0002 12.7936 19.6271 13.1667 19.1668 13.1667H14.1668C13.7066 13.1667 13.3335 12.7936 13.3335 12.3333Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgFilter);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/Filter.9023a9e404b7b3a0e1e189308c5dd060.svg";